// import { BHttp } from '../../service/bHTTP'
import { HttpClient } from '@angular/common/http';
import { SystemService } from '../../service/system.service';
var socialService = (function () {
    function socialService(bHttp) {
        this.bHttp = bHttp;
        this.systemService = new SystemService();
        this.appUrl = this.systemService.getAppUrl();
        this.socialSentimentsUrl = this.appUrl + 'social/sentiments';
        this.missionControlUrl = this.appUrl + 'social/missionControl';
    }
    socialService.prototype.getSetimentsByCategory = function (category) {
        return this.bHttp.post(this.socialSentimentsUrl, { 'sentimentsBy': category }).map(function (res) {
            if (res.hasOwnProperty && res) {
                return res;
            }
            else {
                return [];
            }
        }).catch(function (err) {
            return err;
        });
    };
    socialService.prototype.getMissionControl = function () {
        return this.bHttp.get(this.missionControlUrl).map(function (res) {
            if (res.hasOwnProperty && res) {
                return res;
            }
            else {
                return [];
            }
        }).catch(function (err) {
            return err;
        });
    };
    return socialService;
}());
export { socialService };



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/services/social/social.service.ts.pre-build-optimizer.js